var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VDataTable',{attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":-1},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('VBtn',{on:{"click":function($event){return _vm.goIndex(item.table_name)}}},[_vm._v("一覧へ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }